
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1160:717)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}}),_c('path',{attrs:{"d":"M28 32H16v-1.524c0-1.01.395-1.98 1.098-2.694a3.72 3.72 0 012.652-1.115h4.5a3.72 3.72 0 012.652 1.115A3.84 3.84 0 0128 30.476V32zm-6-6.857a4.44 4.44 0 01-1.722-.348 4.498 4.498 0 01-1.46-.991 4.578 4.578 0 01-.976-1.483 4.635 4.635 0 010-3.499 4.58 4.58 0 01.976-1.483 4.496 4.496 0 011.46-.991A4.438 4.438 0 0122 16c1.194 0 2.338.482 3.182 1.339A4.609 4.609 0 0126.5 20.57a4.609 4.609 0 01-1.318 3.233A4.465 4.465 0 0122 25.143zM33 21.636V24h-3v-2.364h3zM33 13v6.273h-3V13h3z","fill":"#F07300"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1160:717","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1160:717"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1160:717","result":"shape"}})])])])
          )
        }
      }
    